import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import swal from "sweetalert";
import { Paginator } from "primereact/paginator";
import "primeicons/primeicons.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import Role from "../helpers/role";
import API from "../helpers/api";
import { showLoader, hideLoader } from "../Actions/PageLoaderAPI";
import "../App.css";
import "../Asset/css/dashboard.css";
import "../Asset/css/monthly-report-comments-redesign.css";

const PAGE_SIZE = 25;

class ThemeDateInput extends React.Component {
  render() {
    const { value, onClick, placeholder, onChange, iconPosition } = this.props;
    const iconOnLeft = iconPosition === "left";
    const calendarBtn = (
      <div className="input-group-btn calendar-icon" onClick={onClick}>
        <button className="btn btn-default" type="button">
          <i className="fa fa-calendar" aria-hidden="true" />
        </button>
      </div>
    );
    return (
      <div
        className={`input-group add-on date datepicker mrc-date-picker-group${
          iconOnLeft ? " mrc-date-icon-left" : ""
        }`}
      >
        {iconOnLeft ? calendarBtn : null}
        <input
          type="text"
          className="form-control date-picker"
          value={value || ""}
          placeholder={placeholder || ""}
          onClick={onClick}
          onChange={onChange || (() => {})}
          readOnly
        />
        {!iconOnLeft ? calendarBtn : null}
      </div>
    );
  }
}

const formatRecordDate = (fromDate, toDate) => {
  if (!fromDate) {
    return "-";
  }
  const from = Moment(fromDate).format("D MMM YYYY");
  if (!toDate) {
    return from;
  }
  const to = Moment(toDate).format("D MMM YYYY");
  return `${from} to ${to}`;
};

const mapEntry = (entry) => ({
  id: entry.id ?? entry.Id,
  crewId: entry.crewId ?? entry.CrewId ?? "",
  crewName: entry.crewName ?? entry.CrewName ?? "",
  fromDate: entry.fromDate ?? entry.FromDate,
  toDate: entry.toDate ?? entry.ToDate,
  status: entry.status ?? entry.Status ?? "",
  comments: entry.comments ?? entry.Comments ?? "",
  isEditable: entry.isEditable ?? entry.IsEditable ?? true,
});

const getStatusBadgeClass = (status) => {
  const s = (status || "").toLowerCase();
  if (s === "pending") return "mrc-status-badge pending";
  if (s === "reviewed") return "mrc-status-badge reviewed";
  if (s === "partial") return "mrc-status-badge partial";
  return "mrc-status-badge";
};

class MonthlyReportComments extends React.Component {
  constructor(props) {
    super(props);
    const user = JSON.parse(localStorage.getItem("currentUser") || "{}");
    this.state = {
      records: [],
      pageNumber: 1,
      pageSize: PAGE_SIZE,
      totalRecords: 0,
      first: 0,
      SelectedFromDate: null,
      SelectedToDate: null,
      searchData: {
        crewId: "",
        crewName: "",
        fromDate: "",
        toDate: "",
        status: "",
      },
      actionBy: user.email || "",
    };
  }

  componentDidMount() {
    const userRole = localStorage.getItem("UserRoles");
    if (userRole !== Role.staff) {
      this.props.history.replace("/pagenotfound");
      return;
    }
    this.props.dispatch({
      type: "SubBannerTitle",
      data: "Monthly Compliance Reports",
    });
    this.searchEntries(1);
  }

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState((prev) => ({
      searchData: { ...prev.searchData, [name]: value },
    }));
  };

  handleStatusChange = (status) => {
    this.setState((prev) => ({
      searchData: { ...prev.searchData, status },
    }));
  };

  handleFromDateChange = (date) => {
    this.setState((prev) => ({
      SelectedFromDate: date,
      searchData: {
        ...prev.searchData,
        fromDate: date ? Moment(date).format("DD-MMM-YYYY") : "",
      },
    }));
  };

  handleToDateChange = (date) => {
    this.setState((prev) => ({
      SelectedToDate: date,
      searchData: {
        ...prev.searchData,
        toDate: date ? Moment(date).format("DD-MMM-YYYY") : "",
      },
    }));
  };

  buildSearchPayload = (pageNumber) => {
    const { searchData, actionBy, SelectedFromDate, SelectedToDate } = this.state;
    return {
      pageNumber,
      pageSize: PAGE_SIZE,
      shipId: 0,
      crewId: searchData.crewId.trim() || null,
      crewName: searchData.crewName.trim() || null,
      fromDate: SelectedFromDate
        ? Moment(SelectedFromDate).format("YYYY-MM-DD")
        : null,
      toDate: SelectedToDate
        ? Moment(SelectedToDate).format("YYYY-MM-DD")
        : null,
      status: searchData.status || null,
      actionBy,
    };
  };

  searchEntries = (pageNumber = 1) => {
    const { dispatch } = this.props;
    const payload = this.buildSearchPayload(pageNumber);

    dispatch(showLoader());
    axios
      .post(API.SearchComplianceEntry, payload)
      .then((response) => {
        const result = response.data || {};
        const list = (result.data || []).map(mapEntry);
        const pagination = result.pagination || {};
        this.setState({
          records: list,
          pageNumber,
          pageSize: pagination.pageSize || PAGE_SIZE,
          totalRecords: pagination.totalcount || 0,
          first: (pageNumber - 1) * PAGE_SIZE,
        });
      })
      .catch((error) => {
        this.setState({
          records: [],
          totalRecords: 0,
          first: 0,
        });
        const apiMessage =
          (typeof error?.response?.data === "string" && error.response.data) ||
          error?.response?.data?.message ||
          error?.response?.data?.Message ||
          "Unable to load monthly report comments. Please try again.";
        swal("Error!", apiMessage, "warning");
      })
      .finally(() => {
        dispatch(hideLoader());
      });
  };

  applyFilter = () => {
    this.searchEntries(1);
  };

  clearFilter = () => {
    this.setState(
      {
        SelectedFromDate: null,
        SelectedToDate: null,
        searchData: {
          crewId: "",
          crewName: "",
          fromDate: "",
          toDate: "",
          status: "",
        },
      },
      () => this.searchEntries(1)
    );
  };

  onPaginatorChange = (event) => {
    this.setState({ first: event.first });
    this.searchEntries(event.page + 1);
  };

  openEdit = (record) => {
    if (!record?.id) return;
    if (record.isEditable === false) {
      swal(
        "Locked",
        "This period is locked because the monthly report has already been generated.",
        "warning"
      );
      return;
    }
    this.props.history.push(
      `/Home/Management/MonthlyReportComments/${record.id}`
    );
  };

  BacktoPrevious = () => {
    this.props.history.goBack();
  };

  render() {
    const {
      records,
      searchData,
      SelectedFromDate,
      SelectedToDate,
      totalRecords,
      pageSize,
      first,
    } = this.state;

    return (
      <div className="pt-3 mrc-redesign">
        <div className="mrc-page-container">
        <div className="mrc-page-back">
          <button
            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
            onClick={this.BacktoPrevious}
          >
            <div style={{ position: "relative" }}>
              <span className="backarr">&larr;</span>
              <span style={{ marginLeft: "18px" }}>Back</span>
            </div>
          </button>
        </div>

        <div className="mrc-page-card">
            <div className="card MM-card-header mb-0">
              <div
                className="card-body flex"
                style={{
                  padding: "0rem",
                  backgroundColor: "#1a3464",
                  color: "white",
                }}
              >
                <h5 className="card-title mrc-card-title">
                  <span className="mrc-card-title-icon" aria-hidden="true">
                    <i className="fa fa-bar-chart" />
                  </span>
                  <span className="mrc-card-title-text">
                    Monthly Compliance Reports
                  </span>
                </h5>
              </div>
            </div>

            <div className="panel-box search-filter-box mb-0 mrc-filter-panel">
              <div className="mrc-filter-panel-body">
              <div className="row mrc-filter-row">
                <div className="col-12 col-md-4 mrc-filter-field">
                  <label className="form-label">Crew ID</label>
                  <div className="mrc-input-icon-wrap">
                    <i className="fa fa-id-badge" aria-hidden="true" />
                    <input
                      className="form-control mrc-input-with-icon"
                      type="text"
                      name="crewId"
                      placeholder="Enter Crew ID"
                      value={searchData.crewId}
                      onChange={this.handleInputChange}
                    />
                  </div>
                </div>
                <div className="col-12 col-md-4 mrc-filter-field">
                  <label className="form-label">Name</label>
                  <div className="mrc-input-icon-wrap">
                    <i className="fa fa-user-o" aria-hidden="true" />
                    <input
                      className="form-control mrc-input-with-icon"
                      type="text"
                      name="crewName"
                      placeholder="Enter Name"
                      value={searchData.crewName}
                      onChange={this.handleInputChange}
                    />
                  </div>
                </div>
                <div className="col-12 col-md-4 mrc-filter-field">
                  <label className="form-label">Date</label>
                  <div className="mrc-date-range-row">
                    <div className="mrc-datepicker-wrap">
                      <DatePicker
                        selected={SelectedFromDate}
                        onChange={this.handleFromDateChange}
                        maxDate={SelectedToDate || null}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        dateFormat="dd-MMM-yyyy"
                        placeholderText="From"
                        popperPlacement="bottom-start"
                        popperClassName="mrc-datepicker-popper"
                        customInput={
                          <ThemeDateInput
                            placeholder="From"
                            iconPosition="right"
                          />
                        }
                      />
                    </div>
                    <div className="mrc-datepicker-wrap">
                      <DatePicker
                        selected={SelectedToDate}
                        onChange={this.handleToDateChange}
                        minDate={SelectedFromDate || null}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        dateFormat="dd-MMM-yyyy"
                        placeholderText="To"
                        popperPlacement="bottom-end"
                        popperClassName="mrc-datepicker-popper"
                        customInput={
                          <ThemeDateInput
                            placeholder="To"
                            iconPosition="right"
                          />
                        }
                      />
                    </div>
                  </div>
                </div>

                <div className="col-12 mrc-filter-footer">
                  <label className="form-label mrc-status-label">Status</label>
                  <div className="mrc-filter-actions-row">
                    <div className="mrc-radio-options">
                      <label className="mrc-radio-item">
                        <input
                          type="radio"
                          name="status"
                          checked={searchData.status === "Pending"}
                          onChange={() => this.handleStatusChange("Pending")}
                        />
                        Pending
                      </label>
                      <label className="mrc-radio-item">
                        <input
                          type="radio"
                          name="status"
                          checked={searchData.status === "Reviewed"}
                          onChange={() => this.handleStatusChange("Reviewed")}
                        />
                        Reviewed
                      </label>
                      <label className="mrc-radio-item">
                        <input
                          type="radio"
                          name="status"
                          checked={searchData.status === "Partial"}
                          onChange={() => this.handleStatusChange("Partial")}
                        />
                        Partial
                      </label>
                      <label className="mrc-radio-item">
                        <input
                          type="radio"
                          name="status"
                          checked={searchData.status === ""}
                          onChange={() => this.handleStatusChange("")}
                        />
                        All
                      </label>
                    </div>
                    <div className="mrc-search-actions">
                      <button
                        className="btn btn-primary text-uppercase txtside-btn txtht-btn blue mrc-btn-search"
                        type="button"
                        onClick={this.applyFilter}
                      >
                        <span className="mrc-btn-icon" aria-hidden="true">
                          <i className="fa fa-search" />
                        </span>
                        <span>Search</span>
                      </button>
                      <button
                        className="btn btn-light text-uppercase txtside-btn txtht-btn mrc-btn-clear"
                        type="button"
                        onClick={this.clearFilter}
                      >
                        <span className="mrc-btn-icon" aria-hidden="true">
                          <i className="fa fa-refresh" />
                        </span>
                        <span>Clear</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              </div>
            </div>
        </div>

        <div className="mrc-records-list">
          {records.length ? (
            records.map((record) => (
              <div key={record.id} className="card mrc-record-card">
                <div className="mrc-record-layout">
                  <div className="mrc-record-col-block mrc-col-identity">
                    <div className="mrc-field-icon">
                      <i className="fa fa-id-badge" aria-hidden="true" />
                    </div>
                    <div className="mrc-field-body">
                      <div className="mrc-field-line">
                        <span className="mrc-field-label-inline">Crew ID :</span>
                        <span className="mrc-field-value-inline">
                          {record.crewId || "-"}
                        </span>
                      </div>
                      <div className="mrc-field-line">
                        <span className="mrc-field-label-inline">Status :</span>
                        <span className={getStatusBadgeClass(record.status)}>
                          {record.status || "-"}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="mrc-record-col-block mrc-col-name">
                    <div className="mrc-field-icon">
                      <i className="fa fa-user-o" aria-hidden="true" />
                    </div>
                    <div className="mrc-field-body">
                      <p className="mrc-field-label">Name</p>
                      <p className="mrc-field-value">
                        {record.crewName || "-"}
                      </p>
                    </div>
                  </div>
                  <div className="mrc-record-col-block mrc-col-date">
                    <div className="mrc-field-icon">
                      <i className="fa fa-calendar" aria-hidden="true" />
                    </div>
                    <div className="mrc-field-body">
                      <p className="mrc-field-label">Date</p>
                      <p className="mrc-field-value mrc-date-value">
                        {formatRecordDate(record.fromDate, record.toDate)}
                      </p>
                    </div>
                  </div>
                  <div className="mrc-record-col-block mrc-col-action">
                    {record.isEditable !== false ? (
                      <button
                        type="button"
                        className="mrc-icon-btn"
                        title="Edit Comments"
                        onClick={() => this.openEdit(record)}
                      >
                        <i className="fa fa-pencil" aria-hidden="true" />
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="mrc-icon-btn locked"
                        title="Locked - monthly report generated"
                        disabled
                      >
                        <i className="fa fa-lock" aria-hidden="true" />
                      </button>
                    )}
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div
              className="card"
              style={{ overflow: "hidden", position: "relative" }}
            >
              <div className="container">
                <h6 className="resource-list-title no-item-card">
                  !-- No Items to Display --!
                </h6>
              </div>
            </div>
          )}
        </div>

        {totalRecords > 0 ? (
          <div className="mrc-pagination-footer">
            <p className="mrc-pagination-info">
              Showing {first + 1} to{" "}
              {Math.min(first + pageSize, totalRecords)} of {totalRecords}{" "}
              records
            </p>
            <div className="custom-paginator">
              <Paginator
                first={first}
                rows={pageSize}
                totalRecords={totalRecords}
                onPageChange={this.onPaginatorChange}
              />
            </div>
          </div>
        ) : null}
        </div>
      </div>
    );
  }
}

export default connect()(withRouter(MonthlyReportComments));
